import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { Provider } from 'react-redux'
// import store  from './store'
import App from './App'
import theme from './global/theme'
import * as serviceWorker from './serviceWorker'
import { getCookieForUserAuthentication } from './global/cookies'

import store from './redux/store'
import { setUpHttpInterceptors } from './http/interceptors'
import UnrollApi from './http/UnrollApi'
import { NotificationsProvider } from './contexts/Notifications'
import Notificator from './components/new/Notificator'

setUpHttpInterceptors(store, [UnrollApi])

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <NotificationsProvider>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Notificator />
        <BrowserRouter>
          <App key={getCookieForUserAuthentication() || 'userNotLoggedIn'} />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  </NotificationsProvider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
